/**
 * ToolTipLing — desktop-only character tooltip with Ling mascot.
 *
 * Props:
 *   type     'default' | 'happy' | 'curious' | 'question' | 'success'
 *   children  React node — the text content displayed in the tooltip bubble
 *
 * Hidden entirely on mobile (CSS: display none below 1200px).
 */
import s from './ToolTipLing.module.css';

const IMAGE_MAP = {
  default:  '/assets/onboarding/ling-tooltip-point.webp',
  happy:    '/assets/onboarding/ling-tooltip-happy.webp',
  curious:  '/assets/onboarding/ling-tooltip-curious.webp',
  question: '/assets/onboarding/ling-tooltip-point.webp',
  success:  '/assets/onboarding/ling-tooltip-happy.webp',
  type5:    '/assets/onboarding/ling-tooltip-curious.webp',
};

export default function ToolTipLing({ type = 'default', children }) {
  const imgSrc = IMAGE_MAP[type] ?? IMAGE_MAP.default;

  return (
    <div className={s.wrapper} aria-hidden="true">
      {/* Left pill — cream rounded-left; Ling image overflows upward */}
      <div className={s.leftPill}>
        {/* Clip container: 128×151px with overflow:hidden crops cat's feet */}
        <div className={s.lingImgContainer}>
          <img
            src={imgSrc}
            alt=""
            className={s.lingImg}
          />
        </div>
      </div>
      {/* Right pill — text bubble */}
      <div className={s.rightPill}>
        <p className={s.copy}>{children}</p>
      </div>
    </div>
  );
}
